import { pathOr } from 'ramda';

// Any так как CianAnalytics также any и береться из window
//tslint:disable: no-any
export function getCianAnalyticsObject(): { page: any; user: any } {
  const defaultUser = {
    cianUserId: null,
    email: '',
    type: 'not_authorized',
    userId: null,
  };
  const defaultPage = { userId: null, siteType: null };

  return pathOr({ page: defaultPage, user: defaultUser }, ['CianAnalytics', 'service', 'config'], window);
}
